module.exports = __webpack_public_path__ + "img/step1-fr@2x.ecc0e559.webp";